/* eslint-disable no-unused-vars */
import { Link } from "react-router-dom";
import APP_URL, { LONG_NAME } from "../../../declaration/URL";
import BreadCrumbs from "../../../components/BreadCrumbs/BreadCrumbs";
import PageCard from "../../../components/Cards/PageCard";
import { useEffect } from "react";
import { initSelectUser } from "../../common/attendanceSlice/stateDailyAttendance";
import { useDispatch } from "react-redux";
import { SettingCard } from "../../bukken/BukkenSetting";
import PrimaryLabel from "../../../components/label/PrimaryLabel";

function AttendanceSettingTop() {
  const dispatch = useDispatch();
  const crumbs = [{ to: LONG_NAME(APP_URL.bukken.bukkenSetting), title: "設定" }];

  useEffect(() => {
    dispatch(initSelectUser());
  }, []);

  return (
    <div className="page_main_area">
      <BreadCrumbs crumbs={[{ to: "", title: "設定" }]} />
      <PageCard>
        <PrimaryLabel
          title={"勤怠管理"}
          className="w-full pb-1"
          classNameTitle="!text-xl"
        />
        <div className="flex flex-wrap gap-5 mt-2 ml-3">
          <SettingCard to={LONG_NAME(APP_URL.attendance.attendanceSetting)} label="勤怠設定" />
          <SettingCard to={ LONG_NAME(APP_URL.attendance.typeSetting) } label="勤怠区分設定" />
          <SettingCard to={ LONG_NAME(APP_URL.attendance.patternSetting) } label="勤務パターン設定" />
          <SettingCard to={LONG_NAME(APP_URL.attendance.departmentSetting)} label="部署パターン設定" />
          <SettingCard to={LONG_NAME(APP_URL.attendance.employeeSetting)} label="社員パターン設定" />
        </div>
      </PageCard>
    </div>
  );
}

export default AttendanceSettingTop;
